import React, { useState } from 'react';
import * as Styles from './Mockup.style';
import { useHistory } from 'react-router-dom';
import ErrorMessage from 'components/common/red-notification';
// HOOKS
import { useSelector } from 'react-redux';
// Pages
// import ProfileContainer from './profile/Profile.container';
import { useTranslation } from 'react-i18next';
import { mockupMenuData, mockUserUiDetails } from './constant';
import MockupAppDrawer from './mockup-app-drawer/MockupAppDrawer';
import MockupHeader from './mock-header/MockupHeader';

export default function Mockup({ children }) {
  const { t } = useTranslation();
  const [isAppDrawerOpen, setIsAppDrawerOpen] = useState(true);
  const isUserLogout = useSelector((state) => state.user.isUserLogout);
  let history = useHistory();

  //THIS IS FOR HIDING THE PARENT CONTAINER OVERFLOW.
  let value =
    history.location.pathname.split('/')[1] === 'affiliate' || history.location.pathname === '/vs/instance/create';
  const overflowHiddenStyle = value && 'hidden';

  let isWelcomePage = history.location.pathname != '/mockup/welcome';

  return (
    <Styles.MemberNavigatorSC data-testid="member-navigator">
      <MockupAppDrawer menuData={mockupMenuData} />
      <Styles.PageHeaderBodyContainer isUserLogout={isUserLogout}>
        <MockupHeader setIsAppDrawerOpen={setIsAppDrawerOpen} />
        <Styles.PageContainer
          data-testid="page-container"
          onClick={() => (isAppDrawerOpen ? setIsAppDrawerOpen(!isAppDrawerOpen) : {})}
        >
          <Styles.PageContent
            style={{ overflowX: overflowHiddenStyle }}
            data-testid="page-content"
            isAppDrawerOpen={isAppDrawerOpen}
          >
            {/* WELCOME PAGE HAS ITS OWN ERROR MESSAGE IMPLEMENTATION BECAUSE OF ITS BACKGROUND IMAGE */}
            {isWelcomePage && (
              <Styles.Error id="top-warning">
                {mockUserUiDetails.header_messages?.map((data) => {
                  return (
                    data?.id && (
                      <Styles.Warning key={data.id}>
                        <ErrorMessage bgColor={`#${data.color}`} color={`#${data.font_color}`} width="100%">
                          <p>{t(data.api_language_string)} </p>
                        </ErrorMessage>
                      </Styles.Warning>
                    )
                  );
                })}
              </Styles.Error>
            )}
            {children}
          </Styles.PageContent>
        </Styles.PageContainer>
      </Styles.PageHeaderBodyContainer>
    </Styles.MemberNavigatorSC>
  );
}
